import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { clearAuthData } from '../utils/storage';

const AuthLogout: React.FC = () => {
  // Clear auth data immediately for synchronous behavior in tests
  clearAuthData();

  // Also call in useEffect for proper React lifecycle
  useEffect(() => {
    clearAuthData();
  }, []);

  // Redirect to home page
  return <Navigate to="/" replace />;
};

export default AuthLogout;
